export default __webpack_public_path__ + "static/media/rightEgg.53581f98.gif";